export default __webpack_public_path__ + "static/media/EM0310.34I-44681_-26455_0.d5f09bec.jpg";